import { CustomFieldTypeName } from '../../../../../../app/custom-fields/custom-fields.model';

chooseCustomFieldBoxController.$inject = ['$scope', '$mdDialog', 'elementData', '$translate', 'AngularCustomFieldsService'];

export function chooseCustomFieldBoxController($scope, $mdDialog, elementData, $translate, AngularCustomFieldsService) {


$scope.ok = ok;
$scope.cancel = cancel;

const FORBIDDEN_CUSTOM_FIELD_TYPES_IN_BOX = [CustomFieldTypeName.Enumerate, CustomFieldTypeName.Multipicklist]

init();

function ok() {
    const customField = $scope.allCustomFields.find(field => field.id === $scope.elementData.selectedCustomField);
    $scope.elementData.selectedCustomFieldLabel = customField.label;
    $scope.elementData.selectedCustomFieldType = customField.type.type;
    $mdDialog.hide({type: 'ok', data: $scope.elementData});   
}

function cancel() {
    $mdDialog.cancel();
}

  
function init() {
    $scope.elementData = elementData;
    initInputTypeDropdownItems();
    initCustomFieldDropdownItems();
  }


function initInputTypeDropdownItems() {
    $scope.inputTypeDropdownItems = [{
        id: 'variable', 
        label: $translate.instant('parameters/quick_replies/details/input_type_variable')
    },{
        id: 'message', 
        label: $translate.instant('parameters/quick_replies/details/input_type_message')
    }];
}

function initCustomFieldDropdownItems() {
    AngularCustomFieldsService.getFields()
        .toPromise()
        .then((response) => {
            $scope.allCustomFields = response;
            $scope.customFieldDropdownItems = $scope.allCustomFields.filter(
                field => !(FORBIDDEN_CUSTOM_FIELD_TYPES_IN_BOX.includes(field.type.type))
            ).map(field => ({
                'label': field.label + ' (' + field.scope + ' field - ' + field.type.type + ')',
                'id': field.id,
            }));
        });
}

}

